// extracted by mini-css-extract-plugin
module.exports = {"expenseDate":"ExpenseDate_expenseDate__1s0bg"};